import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.png'


const _hoisted_1 = { class: "ml-4 space-y-5 py-5 mb-4" }
const _hoisted_2 = { class: "flex flex-row justify-between gap-x-8 w-full mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-between gap-x-8 w-full"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_5 = { class: "flex justify-between gap-x-8 w-full mt-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "w-6/12" }, null, -1)
const _hoisted_7 = { class: "flex justify-between gap-x-8 w-full mt-4" }
const _hoisted_8 = {
  key: 2,
  class: "flex gap-x-8 w-full"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500" }, " Setiap barang yang dibooking oleh klien akan menyesuaikan dengan layanan yang telah dipilih. ", -1)
const _hoisted_13 = { class: "w-full flex flex-row pt-5" }
const _hoisted_14 = { class: "p-field-checkbox relative mr-32 flex flex-row" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "ml-2.5 text-12px xxl:text-14px cursor-pointer" }, "COD", -1)
const _hoisted_16 = { class: "p-field-checkbox relative flex flex-row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "ml-2.5 text-12px xxl:text-14px cursor-pointer" }, "Delivery Order", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_20 = { class: "flex w-full bg-gray-lp-200 p-4 pl-6 my-6 rounded-md text-black-lp-300" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "w-full pt-2" }, [
  /*#__PURE__*/_createVNode("p", null, "Sama dengan detail Cabang Klien")
], -1)
const _hoisted_22 = { class: "w-2/12 pl-6" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_24 = { class: "flex justify-between gap-x-8 w-full" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center gap-x-2" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("p", { class: "text-14px font-medium" }, "Cash on delivery")
], -1)
const _hoisted_28 = { class: "flex flex-row bg-gray-lp-1200 p-4 rounded-md text-14px w-3/4 mt-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_30 = {
  key: 1,
  class: "p-field-checkbox mt-3 space-x-4 flex flex-row items-center"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-16",
  alt: "cod-logo"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { for: "cod" }, "Delivery fee on delivery", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_34 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_36 = { class: "flex flex-row gap-x-8 w-full mt-4" }
const _hoisted_37 = { class: "flex flex-row gap-x-8 w-full mt-4" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_39 = { class: "flex flex-row gap-x-8 w-full mt-4" }
const _hoisted_40 = { class: "flex justify-between gap-x-8 w-full" }
const _hoisted_41 = { class: "flex justify-between gap-x-8 w-full" }
const _hoisted_42 = { class: "flex justify-between gap-x-8 w-full" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "w-6/12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_TaxSection = _resolveComponent("TaxSection")!
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DetailDeliveryOrder = _resolveComponent("DetailDeliveryOrder")!
  const _component_lp_radio = _resolveComponent("lp-radio")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_BillingSection = _resolveComponent("BillingSection")!
  const _component_BankSection = _resolveComponent("BankSection")!
  const _component_BankSettlementSection = _resolveComponent("BankSettlementSection")!
  const _component_ModalForm = _resolveComponent("ModalForm")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.modelValue)
      ? (_openBlock(), _createBlock(_component_ModalForm, {
          key: 0,
          title: `Ubah Detail ${_ctx.clientType} Client`,
          onClose: _ctx.onClose,
          onSubmit: _ctx.openModalSave,
          isBackgroundFooter: "",
          modalWidth: "w-6/12",
          isDisabled: !_ctx.isFormValid
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_Title, {
                class: "capitalize",
                label: `Detail ${_ctx.clientType} Client`
              }, null, 8, ["label"]),
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_DataWrapper, {
                  label: `Nama ${_ctx.clientType} Client`,
                  class: `${_ctx.clientType === 'induk' ? 'w-1/2' : 'w-full'} capitalize`,
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      type: "text",
                      modelValue: _ctx.detailClient.clientName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailClient.clientName = $event)),
                      placeholder: "Masukan nama Client",
                      onChange: _ctx.fullFilledCodReceiver
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label", "class"]),
                (_ctx.clientType === 'induk')
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      class: "w-1/2",
                      label: "Kategori Client"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectClientCategory,
                          onCloseSelect: _ctx.onCloseSelectClientCategory,
                          isOpenMenu: _ctx.isOpenClientCategory,
                          value: _ctx.detailClient.clientCategory,
                          onChooseSelect: _ctx.onChooseSelectClientCategory,
                          dataSelect: _ctx.clientCategoryList,
                          class: "w-full whitespace-no-wrap my-2 z-10"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.clientType === 'induk')
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode(_component_DataWrapper, {
                      label: "Company Size",
                      class: "w-1/2",
                      asterisk: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Select, {
                          onOpenSelect: _ctx.onOpenSelectCompanySize,
                          onCloseSelect: _ctx.onCloseSelectCompanySize,
                          isOpenMenu: _ctx.isOpenCompanySize,
                          value: _ctx.detailClient.clientCompanySize,
                          onChooseSelect: _ctx.onSelectCompanySize,
                          dataSelect: _ctx.companySizeList,
                          class: "w-full whitespace-no-wrap my-2"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                      ]),
                      _: 1
                    }),
                    _hoisted_4
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DataWrapper, {
                label: "Alamat",
                class: "w-full mt-4",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "textarea",
                    modelValue: _ctx.detailClient.clientAddress,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailClient.clientAddress = $event)),
                    placeholder: "Masukan alamat Client",
                    onChange: _ctx.fullFilledCodAddressReceiver
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_DataWrapper, {
                  label: "Kecamatan, Kota",
                  class: "w-6/12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      isDisabled: _ctx.clientType === 'cabang',
                      class: "my-1",
                      onFilter: _ctx.fetchDistrictList,
                      isLoading: _ctx.loadingDistrictList,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterPOS(''))),
                      options: _ctx.districtList,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: "Ketik atau pilih lokasi",
                      modelValue: _ctx.detailClient.clientDistrict,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailClient.clientDistrict = $event))
                    }, null, 8, ["isDisabled", "onFilter", "isLoading", "options", "modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_6
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_DataWrapper, {
                  label: "Email",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailClient.clientEmail,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailClient.clientEmail = $event)),
                      type: "email",
                      error: _ctx.error.email,
                      onChange: _ctx.validateEmail,
                      errorCaption: "Masukan Email dengan benar",
                      placeholder: "e.g email@gmail.com"
                    }, null, 8, ["modelValue", "error", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "No. Telepon",
                  class: "w-6/12",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectPhoneCountry, {
                      phone: _ctx.detailClient.clientPhone,
                      code: _ctx.clientPhoneDialCode,
                      error: _ctx.errorPhoneMainModal,
                      column: "Kontak",
                      placeholder: "81119600999",
                      onSetPhone: _ctx.onSetDetailClientPhone,
                      onSetPhoneCode: _cache[6] || (_cache[6] = v => (_ctx.clientPhoneDialCode = v))
                    }, null, 8, ["phone", "code", "error", "onSetPhone"])
                  ]),
                  _: 1
                })
              ]),
              (_ctx.clientType === 'induk')
                ? (_openBlock(), _createBlock(_component_TaxSection, {
                    key: 1,
                    form: _ctx.detailClient.clientTax,
                    error: _ctx.error,
                    type: "edit",
                    styleWrapper: "w-full"
                  }, null, 8, ["form", "error"]))
                : (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_DataWrapper, {
                      label: "No. Registrasi Pajak (NPWP)",
                      class: "w-6/12 my-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          format: _ctx.formatted,
                          onChange: _ctx.validateTaxNumber,
                          error: _ctx.error.taxNumber,
                          errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
                          modelValue: _ctx.detailClient.clientTaxNumber,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.detailClient.clientTaxNumber = $event)),
                          placeholder: "00.000.000.0-000.000",
                          maxLength: "20",
                          "show-max-length": ""
                        }, null, 8, ["format", "onChange", "error", "modelValue"])
                      ]),
                      _: 1
                    })
                  ])),
              (_ctx.clientType === 'cabang')
                ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_Title, { label: "Konfigurasi retur" }),
                      _createVNode(_component_ToggleV2, {
                        onClick: _cache[8] || (_cache[8] = () => _ctx.toggleReturnConfig()),
                        "model-value": _ctx.detailClient.isReturnConfig,
                        "style-active": _ctx.toggle-_ctx.active
                      }, null, 8, ["model-value", "style-active"])
                    ]),
                    (_ctx.detailClient.isReturnConfig)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 0,
                          label: "Batas konfirmasi retur",
                          optional: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_LpInput, {
                              modelValue: _ctx.detailClient.returnConfigLimit,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.detailClient.returnConfigLimit = $event)),
                              placeholder: "Batas konfirmasi retur",
                              "max-length": 3,
                              suffix: "hari"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detailClient.isReturnConfig)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 1,
                          label: "Alasan retur perlu dikonfirmasi",
                          optional: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MultipleSelectSearch, {
                              options: _ctx.reasonList,
                              modelValue: _ctx.returnConfigReasonIds,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.returnConfigReasonIds = $event)),
                              modalTitle: "Return Reason List",
                              keyName: "name",
                              keyValue: "value",
                              placeholder: "Pilih alasan",
                              "custom-display-all": "Semua alasan",
                              onFilter: _ctx.onSearchAddObject,
                              class: "py-2"
                            }, null, 8, ["options", "modelValue", "onFilter"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_11,
                    _createVNode(_component_Title, { label: "Layanan Pengiriman" }),
                    _hoisted_12,
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode(_component_Checkbox, {
                          id: "clientIsCod",
                          modelValue: _ctx.detailClient.clientIsCod,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailClient.clientIsCod = $event)),
                          onChange: _cache[12] || (_cache[12] = ()=> {!_ctx.detailClient.clientIsCod ? _ctx.detailClient.clientIsDfod = false : null}),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_15
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode(_component_Checkbox, {
                          id: "clientDeliveryOrder",
                          modelValue: _ctx.detailClient.clientIsDo,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.detailClient.clientIsDo = $event)),
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.detailClient.clientBranchDoPaymentType = '')),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _hoisted_17
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.detailClient.clientIsDo)
                ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                    _hoisted_18,
                    _createVNode(_component_DetailDeliveryOrder, {
                      detailData: _ctx.detailClient,
                      isForm: ""
                    }, null, 8, ["detailData"])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.detailClient.clientIsCod && _ctx.clientType === 'cabang')
                ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                    _hoisted_19,
                    _createVNode(_component_Title, { label: "Pengembalian STT return" }),
                    _createVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode("div", _hoisted_22, [
                        _createVNode("div", {
                          onClick: _cache[15] || (_cache[15] = () => _ctx.autoFill()),
                          class: 
                  `toggle-switch inline-block cursor-pointer ${
                    _ctx.isFill ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                  }`
                
                        }, [
                          _hoisted_23
                        ], 2)
                      ])
                    ]),
                    _createVNode(_component_Title, { label: "Detail Penerima" }),
                    _createVNode(_component_DataWrapper, {
                      label: "Nama Penerima",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          modelValue: _ctx.detailClient.clientCodReject.clientCodName,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodName = $event)),
                          placeholder: "Masukan nama penerima",
                          disabled: _ctx.autoFillColumnDisabled
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DataWrapper, {
                      label: "Alamat Penerima",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          type: "textarea",
                          modelValue: _ctx.detailClient.clientCodReject.clientCodAddress,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodAddress = $event)),
                          placeholder: "Masukan alamat penerima",
                          disabled: _ctx.autoFillColumnDisabled
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_DataWrapper, {
                        label: "Kecamatan, Kota",
                        class: "w-6/12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectSearch, {
                            class: "my-1",
                            onFilter: _ctx.fetchDistrictList,
                            isLoading: _ctx.loadingDistrictList,
                            options: _ctx.districtList,
                            error: _ctx.error.codRejdistrict,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: "Ketik atau pilih lokasi",
                            modelValue: _ctx.detailClient.clientCodReject.clientCodDistrict,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodDistrict = $event)),
                            isDisabled: _ctx.autoFillColumnDisabled
                          }, null, 8, ["onFilter", "isLoading", "options", "error", "modelValue", "isDisabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, {
                        label: "No. Telepon",
                        class: "w-6/12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectPhoneCountry, {
                            phone: _ctx.detailClient.clientCodReject.clientCodPhone,
                            code: _ctx.codRejDialCodeModal,
                            error: _ctx.errorCodRejPhoneModal,
                            column: "Kontak",
                            placeholder: "81119600999",
                            disabled: _ctx.autoFillColumnDisabled,
                            onSetPhone: _ctx.onSetCodRejPhoneModal,
                            onSetPhoneCode: _cache[19] || (_cache[19] = v => (_ctx.codRejDialCodeModal = v))
                          }, null, 8, ["phone", "code", "error", "disabled", "onSetPhone"])
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_25,
                    _createVNode(_component_Title, { label: "Tipe COD" }),
                    (_ctx.isEnableCodOngkir)
                      ? (_openBlock(), _createBlock("div", _hoisted_26, [
                          _hoisted_27,
                          _createVNode("div", _hoisted_28, [
                            _createVNode(_component_lp_radio, {
                              name: "cod",
                              options: _ctx.clientCodConfigAmountDataValue,
                              labels: _ctx.clientCodConfigAmountDataName,
                              modelValue: _ctx.detailClient.clientCodConfigAmount.value,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.detailClient.clientCodConfigAmount.value = $event))
                            }, null, 8, ["options", "labels", "modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_29,
                    (_ctx.isEnableCodOngkir)
                      ? (_openBlock(), _createBlock("div", _hoisted_30, [
                          _createVNode(_component_Checkbox, {
                            id: "cod",
                            modelValue: _ctx.detailClient.clientIsDfod,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.detailClient.clientIsDfod = $event)),
                            onChange: ($event: any) => ({}),
                            binary: true
                          }, null, 8, ["modelValue"]),
                          _hoisted_31,
                          _hoisted_32
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_33,
                    _createVNode(_component_Title, {
                      label: "Biaya & persentase COD",
                      class: "pb-6"
                    }),
                    _createVNode("div", _hoisted_34, [
                      _createVNode(_component_DataWrapper, {
                        label: "Biaya COD",
                        icon: "info",
                        iconActive: "info-red",
                        tooltipDescription: "Biaya COD akan dipotong dari jumlah Biaya COD."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lp_input, {
                            format: _ctx.formatFloat,
                            modelValue: _ctx.detailClient.clientCodReject.clientCodCommission,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.detailClient.clientCodReject.clientCodCommission = $event)),
                            error: _ctx.error.codRejCommision,
                            onChange: _ctx.validateCodRejCommision,
                            errorCaption: _ctx.errorCaptionCodRejCommision,
                            placeholder: "e.g 20",
                            min: "0",
                            max: "100",
                            suffix: "%"
                          }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption"])
                        ]),
                        _: 1
                      }),
                      (_ctx.isEnableCodOngkir)
                        ? (_openBlock(), _createBlock(_component_DataWrapper, {
                            key: 0,
                            label: "Persentase Diskon COD",
                            icon: "info",
                            iconActive: "info-red",
                            tooltipTitle: "Info Persentase Diskon COD",
                            tooltipDescription: _ctx.clientCodShipmentDiscountTootltipDescription
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_lp_input, {
                                format: _ctx.formatFloat,
                                modelValue: _ctx.detailClient.clientCodShipmentDiscount,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.detailClient.clientCodShipmentDiscount = $event)),
                                error: _ctx.error.codShipmentDiscount,
                                onChange: _ctx.validateCodShipmentDiscount,
                                errorCaption: _ctx.errorCaptionCodShipmentDiscount,
                                placeholder: "Masukkan persentase diskon COD",
                                min: "0",
                                max: "30",
                                suffix: "%"
                              }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption"])
                            ]),
                            _: 1
                          }, 8, ["tooltipDescription"]))
                        : _createCommentVNode("", true),
                      (_ctx.isEnableCodBooking)
                        ? (_openBlock(), _createBlock(_component_DataWrapper, {
                            key: 1,
                            label: "Biaya PAD",
                            class: "w-6/12",
                            icon: "info",
                            iconActive: "info-red",
                            tooltipDescription: "Biaya PAD akan ditambahkan ke Biaya PAD"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_lp_input, {
                                format: _ctx.formatFloat,
                                modelValue: _ctx.detailClient.clientPadFee,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.detailClient.clientPadFee = $event)),
                                error: _ctx.error.padCommision,
                                onChange: _ctx.validatePadCommision,
                                errorCaption: _ctx.errorCaptionPadCommision,
                                placeholder: "e.g 20",
                                min: "0",
                                max: "100",
                                suffix: "%"
                              }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_35,
              _createVNode(_component_Title, { label: "Informasi Kontak" }),
              _createVNode("div", _hoisted_36, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Nama"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailClient.clientContact.clientContactName,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.detailClient.clientContact.clientContactName = $event)),
                      placeholder: "Masukan nama"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Jabatan"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailClient.clientContact.clientContactJobTitle,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.detailClient.clientContact.clientContactJobTitle = $event)),
                      placeholder: "Masukan jabatan"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_37, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.detailClient.clientContact.clientContactEmail,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.detailClient.clientContact.clientContactEmail = $event)),
                      onChange: _ctx.validateContactEmail,
                      errorCaption: "Masukan format email dengan benar",
                      error: _ctx.error.contactEmail,
                      placeholder: "e.g email@gmail.com"
                    }, null, 8, ["modelValue", "onChange", "error"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, {
                  label: "No. Telepon",
                  class: "w-1/2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectPhoneCountry, {
                      phone: _ctx.detailClient.clientContact.clientContactPhone,
                      code: _ctx.contactPhoneDialCodeModal,
                      error: _ctx.errorContactPhoneModal,
                      column: "Kontak",
                      placeholder: "81119600999",
                      onSetPhone: _ctx.onSetContactPhoneModal,
                      onSetPhoneCode: _cache[28] || (_cache[28] = v => (_ctx.contactPhoneDialCodeModal = v))
                    }, null, 8, ["phone", "code", "error", "onSetPhone"])
                  ]),
                  _: 1
                })
              ]),
              (_ctx.isClientParent)
                ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                    _hoisted_38,
                    _createVNode(_component_Title, { label: "Informasi Pembayaran" }),
                    _createVNode("div", _hoisted_39, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Metode Pembayaran",
                        asterisk: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CustomDropdown, {
                            modelValue: _ctx.detailClient.clientPaymentMethod,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.detailClient.clientPaymentMethod = $event)),
                            options: _ctx.clientPaymentMethodData,
                            placeholder: "Pilih metode pembayaran",
                            class: "w-full custom-select mt-1.5",
                            isCustomWidth: "",
                            selectedItem: _ctx.detailClient.clientPaymentMethod
                          }, null, 8, ["modelValue", "options", "selectedItem"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.clientType === 'cabang')
                ? (_openBlock(), _createBlock(_Fragment, { key: 7 }, [
                    _createVNode(_component_Title, { label: "Detail Induk Client" }),
                    _createVNode("div", _hoisted_40, [
                      _createVNode(_component_DataWrapper, {
                        label: "Nama Induk Client",
                        class: "w-6/12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lp_input, {
                            modelValue: _ctx.detailClient.clientParentName,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.detailClient.clientParentName = $event)),
                            type: "Nama Induk Client",
                            placeholder: "Masukan atau pilih induk client",
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, {
                        label: "Nama Partner POS",
                        optional: true,
                        class: "w-6/12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelectSearch, {
                            options: _ctx.posList,
                            onFilter: _ctx.filterPOS,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: "Masukan atau pilih POS",
                            modelValue: _ctx.modelPartnerPos,
                            "onUpdate:modelValue": _ctx.onChangePartnerPos,
                            isLoading: _ctx.isLoadingPOS,
                            class: "my-2"
                          }, null, 8, ["options", "onFilter", "modelValue", "onUpdate:modelValue", "isLoading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_41, [
                      _createVNode(_component_DataWrapper, {
                        label: "Komisi",
                        class: "w-6/12",
                        asterisk: _ctx.commissionRequired
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lp_input, {
                            format: _ctx.formatFloat,
                            modelValue: 
                  _ctx.detailClient.clientPartner.clientPartnerCommissionAmount
                ,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (
                  _ctx.detailClient.clientPartner.clientPartnerCommissionAmount
                 = $event)),
                            error: _ctx.error.commission,
                            onChange: _ctx.validateCommision,
                            errorCaption: _ctx.errorCaptionCommision,
                            placeholder: "e.g 20",
                            min: "0",
                            max: "100",
                            suffix: "%",
                            disabled: _ctx.commissionDisabled
                          }, null, 8, ["format", "modelValue", "error", "onChange", "errorCaption", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["asterisk"]),
                      _createVNode(_component_DataWrapper, {
                        label: "Tipe Komisi",
                        class: "w-6/12",
                        asterisk: _ctx.commissionRequired
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            onOpenSelect: _ctx.onOpenSelectCommissionType,
                            onCloseSelect: _ctx.onCloseSelectCommissionType,
                            isOpenMenu: _ctx.isOpenCommissionType,
                            onChooseSelect: _ctx.onSelectCommissionType,
                            dataSelect: _ctx.commisionTypes,
                            isDisabled: _ctx.commissionDisabled,
                            value: 
                  _ctx.detailClient.clientPartner.clientPartnerQuantifierCommission
                ,
                            class: "w-full whitespace-no-wrap my-2"
                          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "dataSelect", "isDisabled", "value"])
                        ]),
                        _: 1
                      }, 8, ["asterisk"])
                    ]),
                    _createVNode("div", _hoisted_42, [
                      _createVNode(_component_DataWrapper, {
                        label: "Pembilang Komisi",
                        class: "w-6/12",
                        asterisk: _ctx.commissionRequired
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            onOpenSelect: _ctx.onOpenSelectNumeratorCommission,
                            onCloseSelect: _ctx.onCloseSelectNumeratorCommission,
                            isOpenMenu: _ctx.isOpenNumeratorCommission,
                            onChooseSelect: _ctx.onSelectNumeratorCommission,
                            dataSelect: _ctx.numeratorCommissionList,
                            isDisabled: _ctx.commissionDisabled,
                            value: 
                  _ctx.detailClient.clientPartner.clientPartnerNumeratorCommision
                ,
                            class: "w-full whitespace-no-wrap my-2"
                          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "dataSelect", "isDisabled", "value"])
                        ]),
                        _: 1
                      }, 8, ["asterisk"]),
                      _hoisted_43
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.clientType === 'induk')
                ? (_openBlock(), _createBlock(_Fragment, { key: 8 }, [
                    _createVNode(_component_BillingSection, {
                      form: _ctx.detailClient.clientBilling,
                      error: _ctx.error,
                      type: "edit",
                      styleWrapper: "w-full pt-5"
                    }, null, 8, ["form", "error"]),
                    _createVNode(_component_BankSection, { isClearDefault: false }),
                    _createVNode(_component_BankSettlementSection, { isClearDefault: false })
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title", "onClose", "onSubmit", "isDisabled"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.editClient,
      onClose: _ctx.closeModalSave,
      title: "Konfirmasi Perubahan",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Detail Client “${_ctx.detailClient.clientName}” ?`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalSuccess,
      title: "Perubahan Disimpan",
      message: `${_ctx.messageSuccess}`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.modalSuccess]
    ]),
    (_ctx.isErrorEdit)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.editClient,
          onCancel: _ctx.closeModalError,
          modal: ""
        }, null, 8, ["errorType", "onTryAgain", "onCancel"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Pembuatan Gagal !",
      message: 
      `Berkas Custom Rates salah atau tidak sesuai.\nSilahkan klik Ubah File untuk perbaiki.`
    ,
      image: "image-modal-failed",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.isErrorDocument]
    ])
  ], 64))
}